import React from "react";
import Helmet from "react-helmet";
import { AppName, cleanDate } from "../../../../util/app";

const DischargeDetail = ({ item, onConfirm }) => {
    if (item)
        return (
            <>
                <Helmet>
                    <title> Patient Discharge | {AppName}</title>
                </Helmet>
                {!item.confirm.status && (
                    <div className="row">
                        <div className="col-3 bg-primary text-center">
                            <h5>Status</h5>
                        </div>
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td style={{ color: "white" }} className="text-center bg-danger" colSpan="4">
                                        <span className="w-100">Unconfirmed</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Form Detail</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Planning Status</strong>
                                </td>
                                <td>{item.status}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Scheduling</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Scheduling Date</strong>
                                </td>
                                <td>{cleanDate(item.date, true, false)}</td>
                                <td style={{ width: "20%" }}>
                                    {item.endOfLife ? (
                                        <div className="row">
                                            <div className="col-2">
                                                <span className="material-icons text-primary">check_box</span>
                                            </div>
                                            <div className="col">
                                                <span>End of Life</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            <div className="col-2">
                                                <span className="material-icons text-primary">check_box_outline_blank</span>
                                            </div>
                                            <div className="col">
                                                <span>End of Life</span>
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td>
                                    {item.homeForLife ? (
                                        <div className="row">
                                            <div className="col-2">
                                                <span className="material-icons text-primary">check_box</span>
                                            </div>
                                            <div className="col">
                                                <span>Home for life</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            <div className="col-2">
                                                <span className="material-icons text-primary">check_box_outline_blank</span>
                                            </div>
                                            <div className="col">
                                                <span>Home for life</span>
                                            </div>
                                        </div>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge Type*</strong>
                                </td>

                                <td colSpan="3">{item.type}</td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Comment*</strong>
                                </td>

                                <td colSpan="3">{item.comment}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Internal Discharge</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Select Service</strong>
                                </td>
                                <td>{item.service}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>External Discharge</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan="2" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address of Discharge Location:</strong>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 1*</strong>
                                </td>

                                <td>{item.external.address1}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 2</strong>
                                </td>

                                <td>{item.external.address2 || "NA"}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 3</strong>
                                </td>
                                <td>{item.external.address3 || "NA"}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>City*</strong>
                                </td>

                                <td>{item.external.city}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Country*</strong>
                                </td>

                                <td>{item.external.country}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Postcode*</strong>
                                </td>

                                <td>{item.external.postcode}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Telephone Number*</strong>
                                </td>

                                <td>{item.external.mobile}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Location Details</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Location Type:</strong>
                                </td>
                                <td>{item.locationType}</td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Level of Security:</strong>
                                </td>
                                <td>{item.securityLevel}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Discharge Documents</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge checklist Documents</strong>
                                </td>
                                <td colSpan="5">
                                    {item.checklistDocument ? (
                                        <button data-toggle="modal" data-target="#preview" type="button" className="btn btn-default">
                                            PreView
                                        </button>
                                    ) : (
                                        <p className="text-danger"> No Discharge checklist Documents</p>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge Summary</strong>
                                </td>
                                <td colSpan="5">
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span className="material-icons text-primary">check_box</span>
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong>
                                                        Documents Sent To: <br />
                                                        (Names and Roles)
                                                    </strong>
                                                </td>
                                                <td>{item.summary[0].comment}</td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong className="text-primary">Documents Sent On:</strong>
                                                </td>
                                                <td>{cleanDate(item.summary[0].date, true)}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="material-icons text-primary">check_box</span>
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong>
                                                        Documents Sent To: <br />
                                                        GP:
                                                    </strong>
                                                </td>
                                                <td>{item.summary[1].comment}</td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong className="text-primary">Documents Sent On:</strong>
                                                </td>
                                                <td>{cleanDate(item.summary[1].date, true)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {item.documents.map((doc, index) => (
                                <tr key={index}>
                                    <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                        <strong>{doc.title}</strong>
                                    </td>
                                    <td style={{ width: "5%" }}>
                                        <span className="material-icons text-primary">check_box</span>
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                        <strong>
                                            Documents Sent To: <br />
                                            (Names and Roles)
                                        </strong>
                                    </td>
                                    <td>
                                        <span>{doc.comment}</span>
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                        <strong className="text-primary">Documents Sent On:</strong>
                                    </td>
                                    <td style={{ width: "15%" }}>{cleanDate(doc.date, true)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="col-12 text-center">
                        <button title="Confirm Discharge" type="button" onClick={onConfirm} className="mdl-button fab mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--raised btn-green">
                            <i className="material-icons">done</i>
                        </button>
                    </div>
                </div>
                <div className="modal fade" id="preview" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Checklist Document
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body text-center">
                                <img src={item.checklistDocument} alt="checklistDocument" width="420" />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    return null;
};

export default DischargeDetail;
